import { ComponentContextIconsEnum, ComponentsContext, ColorPickerPureGeneric, ColumnColorMultiSelectorGeneric, ColorPickerPanelPure, ColorView, CustomFunctionIcon, DiscreteFunctionIcon, UnitStepFunctionIcon, SigmoidFunctionIcon, LogarithmicFunctionIcon, RectangularFunctionIcon, TriangularFunctionIcon, LinearFunctionIcon, DesirabilityFunctionEditor, ResponsiveContainer, RadarChart, MultiplePropertiesSelectorGeneric, MultiplePropertiesSelectorPureGeneric } from '@discngine/moosa-shared-components-gen';
export { RadarChart, ResponsiveContainer } from '@discngine/moosa-shared-components-gen';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { DeleteFilled, CheckOutlined, DownOutlined, CopyOutlined, EllipsisOutlined, PushpinOutlined, PushpinFilled, DragOutlined, HolderOutlined, DownloadOutlined, UploadOutlined, CloseOutlined, SwapOutlined, RightOutlined, DeleteOutlined, FunctionOutlined, SaveOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Input, Select, Tooltip, Popover, Row, Col, Modal, Dropdown, Menu, Empty, Radio, Checkbox, Upload, message, Button, Slider, List, Popconfirm, Alert, theme, Spin, notification } from 'antd';
import React, { useState, useEffect, useCallback, useMemo, useRef, useLayoutEffect } from 'react';
import { decimalFormatter, classNames } from '@discngine/moosa-common';
import { ReasonType, DesirabilityFunctionType, FieldType, getDefaultScoringFunction, SCORING_FUNCTIONS_RULES, useMoosaDataContext, SCORING_FUNCTIONS } from '@discngine/moosa-models';
import isEmpty from 'lodash/isEmpty';
import { HistogramView } from '@discngine/moosa-histogram';
import debounce from 'lodash/debounce';
import { DndProvider } from 'react-dnd';

const ValueInput = React.memo(function ValueInput({ value, onValueChange, disabled, size, className, type, addonAfter, placeholder, }) {
    const [val, setVal] = useState(value);
    useEffect(() => {
        setVal(value);
    }, [value]);
    const resetVal = useCallback(() => {
        setVal(value);
    }, [value]);
    const handleChange = useCallback((event) => {
        setVal(event.target.value);
        onValueChange(event.target.value);
    }, [onValueChange]);
    return (jsx(Input, { addonAfter: addonAfter, className: className, disabled: disabled, placeholder: placeholder, size: size, type: type, value: val, onBlur: resetVal, onChange: handleChange }));
});

const CommonInput = (props) => jsx(Input, { ...props });
const CommonButton = (props) => jsx(Button, { ...props });
const context = {
    Input: CommonInput,
    ValueInput: ValueInput,
    Select: (props) => jsx(Select, { ...props, onChange: props.onSearch }),
    Tooltip: Tooltip,
    Button: CommonButton,
    Popover: Popover,
    Row: Row,
    Col: Col,
    Modal: Modal,
    Icons: {
        [ComponentContextIconsEnum.DeleteIcon]: (props) => jsx(DeleteFilled, { ...props }),
        [ComponentContextIconsEnum.CheckIcon]: (props) => jsx(CheckOutlined, { ...props }),
        [ComponentContextIconsEnum.DownIcon]: (props) => jsx(DownOutlined, { ...props }),
        [ComponentContextIconsEnum.CopyIcon]: (props) => jsx(CopyOutlined, { ...props }),
        [ComponentContextIconsEnum.EllipsisIcon]: (props) => jsx(EllipsisOutlined, { ...props }),
        [ComponentContextIconsEnum.PinIcon]: (props) => jsx(PushpinOutlined, { ...props }),
        [ComponentContextIconsEnum.PinFilledIcon]: (props) => jsx(PushpinFilled, { ...props }),
        [ComponentContextIconsEnum.MoveIcon]: (props) => jsx(DragOutlined, { ...props }),
        [ComponentContextIconsEnum.DragIcon]: (props) => jsx(HolderOutlined, { ...props }),
        [ComponentContextIconsEnum.DownloadIcon]: (props) => jsx(DownloadOutlined, { ...props }),
        [ComponentContextIconsEnum.UploadIcon]: (props) => jsx(UploadOutlined, { ...props }),
        [ComponentContextIconsEnum.CloseIcon]: (props) => jsx(CloseOutlined, { ...props }),
        [ComponentContextIconsEnum.SwapIcon]: (props) => jsx(SwapOutlined, { ...props }),
    },
    Dropdown: Dropdown,
    Menu: Menu,
    MenuItem: Menu.Item,
    Empty: Empty,
    Radio: Radio.Group,
    Checkbox: (props) => (jsx(Checkbox, { ...props, onChange: (event) => props.onChange?.(event.target.checked) })),
    Upload: Upload,
    message: message,
};
/**
 * AntD implementation of ComponentsContext.
 */
const AntComponentsProvider = ({ children }) => {
    return (jsx(ComponentsContext.Provider, { value: context, children: children }));
};

const ColorPickerPure = (props) => (jsx(AntComponentsProvider, { children: jsx(ColorPickerPureGeneric, { ...props }) }));

const ColumnColorMultiSelector = (props) => (jsx(AntComponentsProvider, { children: jsx(ColumnColorMultiSelectorGeneric, { ...props }) }));

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css$b = ".DatasetDetails_module_details__e31505a3 span {\n  color: #e7615a;\n}\n";
var modules_e344a5e7 = {"details":"DatasetDetails_module_details__e31505a3"};
n(css$b,{});

const DatasetDetails = React.memo(function DatasetDetails({ columnsCount, rowsCount, missingValuesCount }) {
    return (jsxs("div", { className: modules_e344a5e7.details, children: [`${columnsCount} Columns / ${rowsCount} Rows /`, jsxs("span", { children: [" ", `${missingValuesCount} Missing Values`, " "] })] }));
});

const SELECTED_MARK_STYLE = { fontSize: '14px', fontWeight: 500 };
const ImportanceSliderView = React.memo(function ImportanceSliderView({ weight, onWeightChange }) {
    const [sliderValue, setSliderValue] = useState(weight);
    const onValueChange = useCallback((val) => {
        const value = Number(val) || 0;
        const weight = value > 10 ? 10 : value < 1 ? 1 : value;
        setSliderValue(weight);
    }, [setSliderValue]);
    const marks = useMemo(() => {
        const sliderMarks = {};
        for (let i = 1; i <= 10; i++) {
            sliderMarks[i] = {
                label: String(i),
                style: weight === i ? SELECTED_MARK_STYLE : {},
            };
        }
        return sliderMarks;
    }, [weight]);
    useEffect(() => {
        setSliderValue(weight);
    }, [weight]);
    return (jsx(Slider, { included: true, marks: marks, max: 10, min: 1, tooltip: { open: false }, value: sliderValue, onAfterChange: onWeightChange, onChange: onValueChange }));
});

var css$a = ".DataSubCell_module_dataSubCell__9f744214 {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n.DataSubCell_module_dataSubCellCompact__9f744214 {\n  display: flex;\n  align-items: center;\n}\n.DataSubCell_module_dataCompact__9f744214 {\n  line-height: 1.2;\n  font-size: 11px;\n}\n.DataSubCell_module_scoreWithVariance__9f744214 {\n  display: flex;\n}\n";
var modules_ad9037fd = {"dataSubCell":"DataSubCell_module_dataSubCell__9f744214","dataSubCellCompact":"DataSubCell_module_dataSubCellCompact__9f744214","dataCompact":"DataSubCell_module_dataCompact__9f744214","scoreWithVariance":"DataSubCell_module_scoreWithVariance__9f744214"};
n(css$a,{});

const DataSubCell = ({ compact, showErrors, showVariance, errorNegative, errorPositive, variance, children, }) => {
    if (compact) {
        return (jsxs("div", { className: modules_ad9037fd.dataSubCellCompact, children: [children, jsxs("div", { className: modules_ad9037fd.dataCompact, children: [showErrors && errorPositive, showVariance && variance, showErrors && errorNegative] })] }));
    }
    return (jsxs("div", { className: modules_ad9037fd.dataSubCell, children: [showErrors && errorPositive, jsxs("div", { className: modules_ad9037fd.scoreWithVariance, children: [children, showVariance && variance] }), showErrors && errorNegative] }));
};

var css$9 = ".FactorsPopover_module_property__29be2e37 {\n  display: flex;\n  width: 200px;\n  align-items: center;\n  padding: 8px 12px 8px 12px;\n  user-select: none;\n}\n.FactorsPopover_module_property__29be2e37:last-of-type {\n  margin-bottom: 0;\n}\n.FactorsPopover_module_property__29be2e37:hover {\n  background-color: #e6f4ff;\n}\n.FactorsPopover_module_color__29be2e37 {\n  width: 8px;\n  height: 18px;\n  flex-shrink: 0;\n}\n.FactorsPopover_module_title__29be2e37 {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.FactorsPopover_module_arrow__29be2e37 {\n  flex-shrink: 0;\n  font-size: 10px;\n}\n";
var modules_d63221ef = {"property":"FactorsPopover_module_property__29be2e37","color":"FactorsPopover_module_color__29be2e37","title":"FactorsPopover_module_title__29be2e37","arrow":"FactorsPopover_module_arrow__29be2e37"};
n(css$9,{});

const Property = ({ colId, color, isPossibleToChangeColor }) => {
    return (jsxs("div", { className: modules_d63221ef.property, children: [jsx("div", { className: modules_d63221ef.color, children: jsx(ColorView, { color: color }) }), jsx("div", { className: modules_d63221ef.title, children: colId }), isPossibleToChangeColor && jsx(RightOutlined, { className: modules_d63221ef.arrow })] }));
};
const FactorsPopover = function FactorsPopover({ barChart, isPossibleToChangeColor, onChangeColumnColor, }) {
    return (jsx(Fragment, { children: barChart.map(({ colId, color }) => (jsxs(Fragment, { children: [isPossibleToChangeColor && (jsx(Popover, { content: jsx(ColorPickerPanelPure, { color: color, onColorChange: (color) => onChangeColumnColor(colId, color) }), placement: "right", children: jsx("div", { children: jsx(Property, { colId: colId, color: color, isPossibleToChangeColor: isPossibleToChangeColor }) }) }, colId)), !isPossibleToChangeColor && (jsx(Property, { colId: colId, color: color, isPossibleToChangeColor: isPossibleToChangeColor }))] }))) }));
};

var css$8 = ".FactorsRenderer_module_factors__6e826397 {\n  align-items: flex-end;\n  display: flex;\n  height: 24px;\n  align-self: flex-end;\n}\n.FactorsRenderer_module_factor__6e826397 {\n  width: 3px;\n  margin-right: 2px;\n}\n.FactorsRenderer_module_overlay__6e826397 .ant-popover-inner-content {\n  margin: 0;\n  padding: 0;\n}\n";
var modules_f2d9aef5 = {"factors":"FactorsRenderer_module_factors__6e826397","factor":"FactorsRenderer_module_factor__6e826397","overlay":"FactorsRenderer_module_overlay__6e826397"};
n(css$8,{});

const FactorsRenderer = function FactorsRenderer({ columnIds, columnIndices, order, score, scoringFunction, isComparisonColumn, onChangeColumnColor, }) {
    const factorMax = useMemo(() => Math.max(...Object.values(score.factors).map((value) => value == null ? -Infinity : value)), [score]);
    const barChart = useMemo(() => order
        .filter((col) => columnIds.includes(col))
        .filter((col) => (isComparisonColumn ? true : scoringFunction[col].isInUse))
        .map((col) => columnIndices[col])
        .map((index) => {
        const factor = score && score.factors[index];
        const colId = columnIds[Number(index)];
        return {
            colId,
            color: scoringFunction[colId].color,
            height: factor && factorMax
                ? `${factor ? Math.ceil((factor / factorMax) * 100) : 0}%`
                : '0',
        };
    }), [
        order,
        columnIds,
        isComparisonColumn,
        scoringFunction,
        columnIndices,
        score,
        factorMax,
    ]);
    return (jsx(Popover, { content: jsx(FactorsPopover, { barChart: barChart, isPossibleToChangeColor: !isComparisonColumn, onChangeColumnColor: onChangeColumnColor }), overlayClassName: modules_f2d9aef5.overlay, placement: "bottom", children: jsx("div", { className: modules_f2d9aef5.factors, children: barChart.map(({ colId, color, height }) => (jsx("div", { className: modules_f2d9aef5.factor, style: {
                    backgroundColor: color,
                    height: height,
                } }, colId))) }) }));
};

var css$7 = ".ScoreRendererAbstract_module_scoreCell__b8b79fd1 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.ScoreRendererAbstract_module_scoreCell__b8b79fd1 .ScoreRendererAbstract_module_variance__b8b79fd1 {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  margin-right: 15px;\n}\n.ScoreRendererAbstract_module_scoreCell__b8b79fd1 .ScoreRendererAbstract_module_positive__b8b79fd1 {\n  color: #15af97;\n}\n.ScoreRendererAbstract_module_scoreCell__b8b79fd1 .ScoreRendererAbstract_module_negative__b8b79fd1 {\n  color: #e7615a;\n}\n.ScoreRendererAbstract_module_hint__b8b79fd1 {\n  max-width: 200px;\n}\n.ScoreRendererAbstract_module_scoreBox__b8b79fd1 {\n  color: #525252;\n  background-color: #f8f8f8;\n  padding: 1px 8px;\n  border: 1px solid #898989;\n  font-size: 12px;\n  line-height: 20px;\n  border-radius: 2px;\n  margin-right: 8px;\n}\n.ScoreRendererAbstract_module_tipList__b8b79fd1 {\n  margin-bottom: 0;\n  padding-left: 16px;\n}\n";
var modules_e5bb0a3b = {"scoreCell":"ScoreRendererAbstract_module_scoreCell__b8b79fd1","variance":"ScoreRendererAbstract_module_variance__b8b79fd1","positive":"ScoreRendererAbstract_module_positive__b8b79fd1","negative":"ScoreRendererAbstract_module_negative__b8b79fd1","hint":"ScoreRendererAbstract_module_hint__b8b79fd1","scoreBox":"ScoreRendererAbstract_module_scoreBox__b8b79fd1","tipList":"ScoreRendererAbstract_module_tipList__b8b79fd1"};
n(css$7,{});

var css$6 = ".ScoringErrors_module_scoringError__2ace8183 {\n  font-size: 12;\n  color: #898989;\n  /* gray-6 */\n}\n";
var modules_349b11b5 = {"scoringError":"ScoringErrors_module_scoringError__2ace8183"};
n(css$6,{});

const ScoringError = ({ base, delta }) => {
    const sign = delta > 0 ? '+' : '';
    return (jsx("div", { className: modules_349b11b5.scoringError, children: `${decimalFormatter.format(base + delta)} (${sign}${decimalFormatter.format(delta)})` }));
};

function messageFromReason(reason, parameter, missingValue) {
    switch (reason) {
        case ReasonType.DoNotCalculate: {
            return `Scoring cannot be calculated as ${parameter} has missing value`;
        }
        case ReasonType.FilteredOff: {
            return `Filter applied on ${parameter}`;
        }
        case ReasonType.ReplacedWithX: {
            return `Scoring calculated using default X value  = ${missingValue?.replaceWith} for parameter ${parameter}`;
        }
        case ReasonType.ReplacedWithY: {
            return `Scoring calculated using default Y value  = ${missingValue?.replaceWithY} for parameter ${parameter}`;
        }
        case ReasonType.ReplacedWithColumn: {
            return `Scoring calculated using alternative column ${missingValue?.replaceWithColumn} for parameter ${parameter}`;
        }
        default: {
            return '';
        }
    }
}
const ScoreRendererAbstract = ({ columnIds, columnIndices, order, score, scoringFunction, showErrors, variance, isComparisonColumn, isComparisonMode, hasComparisonTemplate, compact = false, onChangeColumnColor, }) => {
    if (!score && isComparisonMode && isComparisonColumn) {
        const hint = 'Scoring cannot be calculated as comparison scoring template is not set or there are no columns in it';
        return (jsx(Popover, { content: hint, overlayClassName: modules_e5bb0a3b.hint, placement: "bottom", children: jsx("div", { className: "text-center", children: "N/A" }) }));
    }
    else if (!score) {
        return null;
    }
    // case #7 https://quantori.atlassian.net/l/c/huT6AxrF
    if (score.value === 0 &&
        Object.keys(score.factors).length === 0 &&
        Object.keys(scoringFunction).length !== 0) {
        const hint = 'None of added parameters is applicable to this dataset';
        return (jsx(Popover, { content: hint, overlayClassName: modules_e5bb0a3b.hint, placement: "bottom", children: jsx("div", { className: "text-center", children: "N/A" }) }));
    }
    const titleRows = Object.keys(score.reasons).map((key) => {
        const parameterIndex = +key;
        const reason = score.reasons[parameterIndex];
        const parameterName = columnIds[parameterIndex];
        const missingValue = scoringFunction[columnIds[parameterIndex]]?.missingValue;
        return messageFromReason(reason, parameterName, missingValue);
    });
    const multilineHint = titleRows.length ? (jsx("ol", { className: modules_e5bb0a3b.tipList, children: titleRows.map((row) => (jsx("li", { children: row }, row))) })) : null;
    if (score.value === null || !Object.keys(score.factors).length) {
        const hint = isEmpty(scoringFunction) || isEmpty(multilineHint)
            ? 'Scoring cannot be calculated as scoring template is not set or there are no columns in it'
            : multilineHint;
        return (jsx(Popover, { content: hint, overlayClassName: modules_e5bb0a3b.hint, placement: "bottom", children: jsx("div", { className: "text-center", children: "N/A" }) }));
    }
    const scoreBox = (jsx("div", { className: modules_e5bb0a3b.scoreBox, children: decimalFormatter.format(score.value) }));
    return (jsxs("div", { className: modules_e5bb0a3b.scoreCell, children: [jsx(DataSubCell, { compact: compact, errorNegative: jsx(ScoringError, { base: score.value, delta: score.totalMeasurementError.negative }), errorPositive: jsx(ScoringError, { base: score.value, delta: score.totalMeasurementError.positive }), showErrors: showErrors, showVariance: isComparisonMode && hasComparisonTemplate && !isComparisonColumn, variance: jsx("div", { className: classNames(modules_e5bb0a3b.variance, {
                        [modules_e5bb0a3b.positive]: variance > 0,
                        [modules_e5bb0a3b.negative]: variance < 0,
                    }), children: `${variance > 0 ? '+' : ''}${variance.toFixed(2)}` }), children: multilineHint ? (jsx(Popover, { content: multilineHint, overlayClassName: modules_e5bb0a3b.hint, placement: "bottom", children: scoreBox })) : (scoreBox) }), jsx(FactorsRenderer, { columnIds: columnIds, columnIndices: columnIndices, isComparisonColumn: isComparisonColumn, order: order, score: score, scoringFunction: scoringFunction, onChangeColumnColor: onChangeColumnColor })] }));
};

const getIcon = (type) => {
    switch (type) {
        case DesirabilityFunctionType.linear:
            return jsx(LinearFunctionIcon, {});
        case DesirabilityFunctionType.triangular:
            return jsx(TriangularFunctionIcon, {});
        case DesirabilityFunctionType.rectangular:
            return jsx(RectangularFunctionIcon, {});
        case DesirabilityFunctionType.logarithmic:
            return jsx(LogarithmicFunctionIcon, {});
        case DesirabilityFunctionType.sigmoid:
            return jsx(SigmoidFunctionIcon, {});
        case DesirabilityFunctionType.unitStep:
            return jsx(UnitStepFunctionIcon, {});
        case DesirabilityFunctionType.discrete:
            return jsx(DiscreteFunctionIcon, {});
        case DesirabilityFunctionType.custom:
            return jsx(CustomFunctionIcon, {});
        default:
            ((x) => {
                throw new Error('Unexpected desirability function type');
            })();
    }
};

var css$5 = ".DesirabilityFunctionTemplatesListDialog_module_modal__b34924d6 {\n  flex-direction: column;\n  max-height: 100%;\n  overflow: hidden;\n}\n.DesirabilityFunctionTemplatesListDialog_module_modal__b34924d6 .ant-modal-content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: min(100vh, 600px);\n  max-height: min(100vh, 600px);\n}\n.DesirabilityFunctionTemplatesListDialog_module_modal__b34924d6 .ant-modal-body {\n  overflow: hidden;\n  display: flex;\n  flex: 1;\n}\n.DesirabilityFunctionTemplatesListDialog_module_wrapper__b34924d6 {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  align-items: center;\n  flex: 1;\n  gap: 16px;\n}\n.DesirabilityFunctionTemplatesListDialog_module_preview__b34924d6 {\n  width: 100%;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.DesirabilityFunctionTemplatesListDialog_module_listWrapper__b34924d6 {\n  width: 100%;\n  overflow: auto;\n  display: flex;\n}\n.DesirabilityFunctionTemplatesListDialog_module_list__b34924d6 {\n  flex: auto;\n}\n.DesirabilityFunctionTemplatesListDialog_module_listItem__b34924d6 {\n  cursor: pointer;\n}\n.DesirabilityFunctionTemplatesListDialog_module_listItem__b34924d6.DesirabilityFunctionTemplatesListDialog_module_selected__b34924d6 {\n  cursor: initial;\n  background-color: #eaeaea;\n}\n.DesirabilityFunctionTemplatesListDialog_module_listItemIcon__b34924d6 {\n  line-height: 15px;\n  margin-right: 8px;\n}\n";
var modules_46ead80e = {"modal":"DesirabilityFunctionTemplatesListDialog_module_modal__b34924d6","wrapper":"DesirabilityFunctionTemplatesListDialog_module_wrapper__b34924d6","preview":"DesirabilityFunctionTemplatesListDialog_module_preview__b34924d6","listWrapper":"DesirabilityFunctionTemplatesListDialog_module_listWrapper__b34924d6","list":"DesirabilityFunctionTemplatesListDialog_module_list__b34924d6","listItem":"DesirabilityFunctionTemplatesListDialog_module_listItem__b34924d6","selected":"DesirabilityFunctionTemplatesListDialog_module_selected__b34924d6","listItemIcon":"DesirabilityFunctionTemplatesListDialog_module_listItemIcon__b34924d6"};
n(css$5,{});

const OFFSET = 50;
const DesirabilityFunctionTemplatesListDialog = ({ metadata, visible, infinityListProps, onSearch, onCancel, onDelete, onSelect, }) => {
    const [desirability, setDesirability] = useState();
    const [search, setSearch] = useState('');
    const debouncedOnSearch = useMemo(() => {
        return debounce((query) => onSearch(query), 300);
    }, [onSearch]);
    // This needs to reload the data (e.g., otherwise, after changing a discrete function
    // to a linear one, the 'hasMore' flag remains in the previous state)
    useEffect(() => {
        if (visible) {
            infinityListProps.revalidate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
    useEffect(() => {
        debouncedOnSearch(search);
    }, [debouncedOnSearch, search]);
    const { data: customFunctions, loadNext, isLoading, hasMore, revalidate, } = infinityListProps;
    const onLoadMore = useCallback((event) => {
        const { target } = event;
        const targetElement = target;
        const isScrolled = targetElement.scrollTop + targetElement.offsetHeight >=
            targetElement.scrollHeight - OFFSET;
        if (isScrolled && hasMore && !isLoading) {
            loadNext();
        }
    }, [hasMore, isLoading, loadNext]);
    const handleDelete = useCallback(async (id) => {
        await onDelete(id);
        revalidate();
    }, [onDelete, revalidate]);
    const currentExistingFunctions = useMemo(() => {
        if (metadata.type === FieldType.String && metadata.isDiscreteColumn) {
            return customFunctions.filter((func) => func.isDiscreteStringFunction);
        }
        else if (metadata.type === FieldType.Number && metadata.isDiscreteColumn) {
            return customFunctions.filter((func) => !func.isDiscreteStringFunction);
        }
        else {
            return customFunctions.filter((func) => func.type !== DesirabilityFunctionType.discrete);
        }
    }, [customFunctions, metadata.isDiscreteColumn, metadata.type]);
    const iScoringFuncProp = useMemo(() => {
        if (!desirability)
            return null;
        const props = getDefaultScoringFunction(metadata);
        props.type = desirability.type;
        props.name = desirability.name;
        props.functionParams[props.type] = SCORING_FUNCTIONS_RULES[props.type].fromServerTemplate(desirability.points, metadata);
        props.isDiscreteStringFunction = desirability.isDiscreteStringFunction;
        return props;
    }, [desirability, metadata]);
    const onModalClose = useCallback(() => {
        onCancel();
        setSearch('');
    }, [onCancel]);
    useEffect(() => {
        if (!desirability)
            return;
        if (!customFunctions.some(({ _id }) => _id === desirability._id)) {
            setDesirability(undefined);
        }
    }, [customFunctions, desirability]);
    return (jsx(Modal, { centered: true, className: modules_46ead80e.modal, destroyOnClose: true, okButtonProps: { disabled: !desirability }, okText: "Select", open: visible, title: "Custom desirability functions", width: 600, onCancel: onModalClose, onOk: () => {
            if (!desirability)
                return;
            onSelect(desirability);
            onModalClose();
        }, children: jsxs("div", { className: modules_46ead80e.wrapper, children: [jsxs("div", { className: modules_46ead80e.preview, children: [!iScoringFuncProp && (jsx(Empty, { description: "Select the function below to see a preview", image: Empty.PRESENTED_IMAGE_SIMPLE })), iScoringFuncProp && (jsxs(Fragment, { children: [jsx(HistogramView, { desirability: iScoringFuncProp, height: 175, metadata: metadata, width: 300, onAddFunctionPoint: () => { }, onMoveFinish: () => { }, onRemoveFunctionPoint: () => { }, onUpdateFunctionPoint: () => { } }), jsx("b", { children: iScoringFuncProp.name })] }))] }), jsx(Input, { placeholder: "Enter function name...", value: search, onChange: (event) => setSearch(event.target.value) }), jsx("div", { className: modules_46ead80e.listWrapper, onScroll: onLoadMore, children: jsx(List, { className: modules_46ead80e.list, dataSource: currentExistingFunctions, renderItem: (item) => (jsxs(List.Item, { actions: [
                                jsx(Popconfirm, { title: "Are you sure to delete this function?", zIndex: 1300, onConfirm: () => handleDelete(item._id), children: jsx(Button, { danger: true, icon: jsx(DeleteOutlined, {}), size: "small", type: "text" }) }),
                            ], className: classNames(modules_46ead80e.listItem, {
                                [modules_46ead80e.selected]: desirability?._id === item._id,
                            }), onClick: () => setDesirability(item), children: [jsx("span", { className: modules_46ead80e.listItemIcon, children: getIcon(item.type) }), item.name] }, item._id)), rowKey: "_id" }) })] }) }));
};

var css$4 = ".ColumnPropertyPanel_module_panel__8ed50969 {\n  border-radius: 8px;\n  background: #FFFFFF;\n}\n.ColumnPropertyPanel_module_panelOuter__8ed50969 {\n  border: 1px solid #dddddd;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-content: stretch;\n  margin-bottom: 8px;\n}\n.ColumnPropertyPanel_module_notUsedColumn__8ed50969 {\n  border: 1px solid #f1f1f1;\n}\n.ColumnPropertyPanel_module_arrow__8ed50969 {\n  font-size: 14px;\n  color: #898989;\n  margin: 1px;\n}\n.ColumnPropertyPanel_module_panelHeader__8ed50969 {\n  padding: 12px 8px 12px 16px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  border-radius: 8px 8px 0 0;\n  background-color: rgba(0, 77, 103, 0.08);\n  height: 40px;\n}\n.ColumnPropertyPanel_module_notUsedColPanelHeader__8ed50969 {\n  background-color: #f8f8f8;\n}\n.ColumnPropertyPanel_module_infoCircle__8ed50969 {\n  margin-left: 5px;\n  color: #dddddd;\n  width: 16.25px;\n  height: 16.25px;\n}\n.ColumnPropertyPanel_module_anchor__8ed50969 {\n  user-select: none;\n  height: 16px;\n  width: 7px;\n  border-left: 2px solid #898989;\n  border-right: 2px solid #898989;\n}\n.ColumnPropertyPanel_module_colorPicker__8ed50969 {\n  position: absolute;\n  top: 14px;\n  left: 14px;\n}\n.ColumnPropertyPanel_module_handleUsed__8ed50969 {\n  padding-top: 20px;\n}\n.ColumnPropertyPanel_module_handleUsedNoFilter__8ed50969 {\n  padding-top: 10px;\n}\n.ColumnPropertyPanel_module_handle__8ed50969 {\n  width: 24px;\n}\n.ColumnPropertyPanel_module_twitterPicker__8ed50969 {\n  position: absolute !important;\n  margin-top: 95px;\n  z-index: 200  ;\n  left: -5px;\n}\n.ColumnPropertyPanel_module_main__8ed50969 {\n  flex-grow: 1;\n  padding: 0 16px 12px 16px;\n  min-width: 0;\n}\n.ColumnPropertyPanel_module_colName__8ed50969 {\n  font-size: 14px;\n  line-height: 32px;\n  font-weight: bold;\n  color: #000000;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 12px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n.ColumnPropertyPanel_module_colName__8ed50969 .ColumnPropertyPanel_module_colorViewWrapper__8ed50969 {\n  height: 20px;\n  width: 12px;\n  padding: 2px;\n}\n.ColumnPropertyPanel_module_colName__8ed50969 .ColumnPropertyPanel_module_numberOfErrors__8ed50969 {\n  display: flex;\n  width: 16px;\n  height: 16px;\n  background-color: #e7615a;\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  margin-left: 3px;\n  cursor: default;\n}\n.ColumnPropertyPanel_module_colName__8ed50969 .ColumnPropertyPanel_module_select__8ed50969 {\n  max-width: calc(100% - 68px);\n  flex: 1;\n}\n.ColumnPropertyPanel_module_colName__8ed50969 .ColumnPropertyPanel_module_focusOnSelect__8ed50969 {\n  width: calc(100% - 68px);\n}\n.ColumnPropertyPanel_module_panelExtend__8ed50969 {\n  padding: 0 16px 16px 16px;\n}\n.ColumnPropertyPanel_module_propertyLabel__8ed50969 {\n  font-size: 12px;\n  color: #757575;\n}\n.ColumnPropertyPanel_module_propertyTextNotUsed__8ed50969 {\n  font-size: 14px;\n  color: #525252;\n  text-align: center;\n  margin: 13px 0 25px 0;\n}\n.ColumnPropertyPanel_module_importance__8ed50969 {\n  padding-top: 6px;\n}\n.ColumnPropertyPanel_module_propertyText__8ed50969 {\n  font-size: 14px;\n  line-height: 14px;\n  color: #212121;\n  font-weight: bold;\n}\n.ColumnPropertyPanel_module_icons__8ed50969 {\n  color: #004d67;\n}\n.ColumnPropertyPanel_module_toggleArrow__8ed50969 {\n  color: #c1c1c1;\n  width: 11.18px;\n  margin: 0 15px;\n}\n.ColumnPropertyPanel_module_splitter__8ed50969 {\n  opacity: 0.5;\n  border-color: #dddddd;\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  margin-bottom: 8px;\n}\n.ColumnPropertyPanel_module_missingValue__8ed50969 {\n  margin-left: 6px;\n  color: #e7615a;\n  font-size: 15.31px;\n}\n.ColumnPropertyPanel_module_buttonWrapper__8ed50969 {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.ColumnPropertyPanel_module_functionBlockTitle__8ed50969 {\n  text-transform: uppercase;\n  color: #dddddd;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 9px 12px 15px;\n}\n";
var modules_dd360949 = {"panel":"ColumnPropertyPanel_module_panel__8ed50969","panelOuter":"ColumnPropertyPanel_module_panelOuter__8ed50969","notUsedColumn":"ColumnPropertyPanel_module_notUsedColumn__8ed50969","arrow":"ColumnPropertyPanel_module_arrow__8ed50969","panelHeader":"ColumnPropertyPanel_module_panelHeader__8ed50969","notUsedColPanelHeader":"ColumnPropertyPanel_module_notUsedColPanelHeader__8ed50969","infoCircle":"ColumnPropertyPanel_module_infoCircle__8ed50969","anchor":"ColumnPropertyPanel_module_anchor__8ed50969","colorPicker":"ColumnPropertyPanel_module_colorPicker__8ed50969","handleUsed":"ColumnPropertyPanel_module_handleUsed__8ed50969","handleUsedNoFilter":"ColumnPropertyPanel_module_handleUsedNoFilter__8ed50969","handle":"ColumnPropertyPanel_module_handle__8ed50969","twitterPicker":"ColumnPropertyPanel_module_twitterPicker__8ed50969","main":"ColumnPropertyPanel_module_main__8ed50969","colName":"ColumnPropertyPanel_module_colName__8ed50969","colorViewWrapper":"ColumnPropertyPanel_module_colorViewWrapper__8ed50969","numberOfErrors":"ColumnPropertyPanel_module_numberOfErrors__8ed50969","select":"ColumnPropertyPanel_module_select__8ed50969","focusOnSelect":"ColumnPropertyPanel_module_focusOnSelect__8ed50969","panelExtend":"ColumnPropertyPanel_module_panelExtend__8ed50969","propertyLabel":"ColumnPropertyPanel_module_propertyLabel__8ed50969","propertyTextNotUsed":"ColumnPropertyPanel_module_propertyTextNotUsed__8ed50969","importance":"ColumnPropertyPanel_module_importance__8ed50969","propertyText":"ColumnPropertyPanel_module_propertyText__8ed50969","icons":"ColumnPropertyPanel_module_icons__8ed50969","toggleArrow":"ColumnPropertyPanel_module_toggleArrow__8ed50969","splitter":"ColumnPropertyPanel_module_splitter__8ed50969","missingValue":"ColumnPropertyPanel_module_missingValue__8ed50969","buttonWrapper":"ColumnPropertyPanel_module_buttonWrapper__8ed50969","functionBlockTitle":"ColumnPropertyPanel_module_functionBlockTitle__8ed50969"};
n(css$4,{});

var css$3 = ".DesirabilityFunctionSelect_module_selectRow__571c9b63 {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.DesirabilityFunctionSelect_module_select__571c9b63 {\n  flex: 1;\n}\n.DesirabilityFunctionSelect_module_button__571c9b63 {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.DesirabilityFunctionSelect_module_button__571c9b63:hover {\n  background-color: rgba(0, 77, 103, 0.1);\n}\n.DesirabilityFunctionSelect_module_modalContainer__571c9b63 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.DesirabilityFunctionSelect_module_input__571c9b63 {\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n.DesirabilityFunctionSelect_module_selectItem__571c9b63 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n.DesirabilityFunctionSelect_module_selectItem__571c9b63 svg {\n  color: #373737;\n}\n";
var modules_9ea30d7a = {"selectRow":"DesirabilityFunctionSelect_module_selectRow__571c9b63","select":"DesirabilityFunctionSelect_module_select__571c9b63","button":"DesirabilityFunctionSelect_module_button__571c9b63","modalContainer":"DesirabilityFunctionSelect_module_modalContainer__571c9b63","input":"DesirabilityFunctionSelect_module_input__571c9b63","selectItem":"DesirabilityFunctionSelect_module_selectItem__571c9b63"};
n(css$3,{});

const WRONG_CHARACTERS = /[#$<>,.\\|/?!%+;:~`'[\]{}]/;
const DesirabilityFunctionSaveDialog = ({ visible, onSave, onCancel, functionName }) => {
    const [name, setName] = useState('');
    const [input, setInput] = useState(null);
    const dataService = useMoosaDataContext();
    const [isChecking, setIsChecking] = useState(false);
    const [existingId, setExistingId] = useState();
    useEffect(() => {
        if (!input) {
            return;
        }
        const text = input.value;
        input.setSelectionRange(text.length - 4, text.length);
    }, [input]);
    const hasWrongChars = useMemo(() => WRONG_CHARACTERS.test(name), [name]);
    const error = useMemo(() => {
        let error;
        if (existingId) {
            error = {
                type: 'warning',
                message: 'A function with the same name already exists and will be overwritten',
            };
        }
        else if (hasWrongChars) {
            error = {
                type: 'error',
                message: `Function name cannot contain special characters like: #$<>,.|/?!%+;:~\`'[]{}`,
            };
        }
        else {
            return null;
        }
        return error;
    }, [existingId, hasWrongChars]);
    const cannotSubmit = !name || hasWrongChars || error?.type === 'error' || isChecking;
    const handleCheckName = useMemo(() => debounce(async (name) => {
        if (!name.trim())
            return;
        setIsChecking(true);
        try {
            const response = await dataService.checkDesirabilityFunctionName({
                name,
            });
            setExistingId(response.success ? undefined : response.existingId);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setIsChecking(false);
        }
    }, 500), [dataService]);
    const handleSave = useCallback(async () => {
        try {
            await onSave(name, existingId);
            onCancel();
        }
        catch (error) {
            message.error(error.message);
        }
    }, [onSave, onCancel, name, existingId]);
    const onKeyUp = useCallback((event) => {
        if (event.key === 'Enter') {
            handleSave();
        }
    }, [handleSave]);
    const handleNameChange = ({ target }) => {
        const value = target.value.trim();
        setName(value);
        handleCheckName(value);
    };
    useEffect(() => {
        if (!visible)
            return;
        setName(functionName);
        handleCheckName(functionName);
    }, [functionName, visible, handleCheckName]);
    const okText = useMemo(() => {
        if (isChecking)
            return 'Checking...';
        if (existingId)
            return 'Update';
        return 'Save';
    }, [isChecking, existingId]);
    return (jsx(Modal, { centered: true, destroyOnClose: true, okButtonProps: { disabled: cannotSubmit }, okText: okText, open: visible, title: "Save desirability function", width: 400, onCancel: onCancel, onOk: handleSave, children: jsxs("div", { className: modules_9ea30d7a.modalContainer, children: [jsx("label", { children: "Function name" }), jsx("input", { ref: setInput, autoFocus: true, className: modules_9ea30d7a.input, type: "text", value: name, onChange: handleNameChange, onKeyUp: cannotSubmit ? undefined : onKeyUp }), error && jsx(Alert, { ...error })] }) }));
};

const DesirabilityFunctionSelect = React.memo(({ desirability, metadata, onChangeScoringFunction, onSave, onDelete, onSearch, infinityListProps, }) => {
    const [templateName, setTemplateName] = useState();
    const [listDialogVisible, setListDialogVisible] = useState(false);
    const [saveDialogVisible, setSaveDialogVisible] = useState(false);
    const handleSave = useCallback(async (name, id) => {
        await onSave({ ...desirability, name }, id);
        setTemplateName(name);
    }, [desirability, onSave]);
    const typeOptions = useMemo(() => {
        let options = [];
        if (metadata.isDiscreteColumn && metadata.type === FieldType.String) {
            options = SCORING_FUNCTIONS.filter((func) => func.type === DesirabilityFunctionType.discrete);
        }
        else if (!metadata.isDiscreteColumn) {
            options = SCORING_FUNCTIONS.filter((func) => func.type !== DesirabilityFunctionType.discrete);
        }
        else {
            options = SCORING_FUNCTIONS;
        }
        return options.map(({ name, type }) => ({
            label: (jsxs("div", { className: modules_9ea30d7a.selectItem, children: [name, getIcon(type)] })),
            value: type,
        }));
    }, [metadata.isDiscreteColumn, metadata.type]);
    const isSaveDisabled = useMemo(() => {
        if (desirability.type !== DesirabilityFunctionType.discrete) {
            return false;
        }
        const funcParams = desirability.functionParams[DesirabilityFunctionType.discrete];
        if (funcParams?.points.length === 0) {
            return true;
        }
        if (SCORING_FUNCTIONS_RULES.discrete.toServerTemplate(funcParams).length === 0) {
            return true;
        }
        return false;
    }, [desirability.functionParams, desirability.type]);
    const handleChangeType = useCallback((type) => {
        const name = SCORING_FUNCTIONS.find((item) => item.type === type)?.name;
        const params = SCORING_FUNCTIONS_RULES[type].init(metadata);
        if (!name || !params)
            return;
        const updated = structuredClone(desirability);
        updated.name = name;
        updated.type = type;
        updated.functionParams[updated.type] = params;
        onChangeScoringFunction(updated);
        setTemplateName(undefined);
    }, [desirability, metadata, onChangeScoringFunction]);
    const onDesirabilityFunctionTemplateSelect = useCallback((newDesirability) => {
        const updated = structuredClone(desirability);
        updated.name = newDesirability.name;
        updated.type = newDesirability.type;
        updated.isDiscreteStringFunction = newDesirability.isDiscreteStringFunction;
        updated.functionParams[updated.type] = SCORING_FUNCTIONS_RULES[updated.type].fromServerTemplate(newDesirability.points, metadata);
        onChangeScoringFunction(updated);
        setTemplateName(newDesirability.name);
    }, [desirability, metadata, onChangeScoringFunction]);
    return (jsxs(Fragment, { children: [jsxs("div", { className: modules_9ea30d7a.selectRow, children: [jsx("div", { className: modules_dd360949.propertyLabel, style: { marginRight: 8 }, children: "Type:" }), jsx(Select, { className: modules_9ea30d7a.select, options: typeOptions, size: "small", value: desirability.type, onChange: handleChangeType }), jsx(Tooltip, { overlayInnerStyle: { borderRadius: '4px' }, title: "Custom desirability functions", children: jsx(Button, { className: modules_9ea30d7a.button, icon: jsx(FunctionOutlined, {}), shape: "circle", size: "small", type: "text", onClick: () => setListDialogVisible(true) }) }), jsx(Tooltip, { overlayInnerStyle: { borderRadius: '4px' }, title: "Save as a custom function", children: jsx(Button, { className: modules_9ea30d7a.button, disabled: isSaveDisabled, icon: jsx(SaveOutlined, {}), shape: "circle", size: "small", type: "text", onClick: () => setSaveDialogVisible(true) }) })] }), templateName && (jsxs("div", { style: { color: '#999', fontSize: 12 }, children: ["Created from: ", jsx("i", { children: templateName })] })), jsx(DesirabilityFunctionSaveDialog, { functionName: desirability.name || '', visible: saveDialogVisible, onCancel: () => setSaveDialogVisible(false), onSave: handleSave }), jsx(DesirabilityFunctionTemplatesListDialog, { infinityListProps: infinityListProps, metadata: metadata, visible: listDialogVisible, onCancel: () => setListDialogVisible(false), onDelete: onDelete, onSearch: onSearch, onSelect: onDesirabilityFunctionTemplateSelect })] }));
});

const DesirabilityFunction = React.memo(function DesirabilityFunction({ desirability, metadata, onParamsChange, onAddFunctionPoint, onUpdateFunctionPoint, onRemoveFunctionPoint, onChangeScoringFunction, onSave, onDelete, onSearch, onMoveFinish, onDiscretePointsOrderChange, infinityListProps, barsRerender, }) {
    return (jsxs(Fragment, { children: [jsx(DesirabilityFunctionSelect, { desirability: desirability, infinityListProps: infinityListProps, metadata: metadata, onChangeScoringFunction: onChangeScoringFunction, onDelete: onDelete, onSave: onSave, onSearch: onSearch }), jsx(AntComponentsProvider, { children: jsx(DesirabilityFunctionEditor, { barsRerender: barsRerender, desirability: desirability, metadata: metadata, onAddFunctionPoint: onAddFunctionPoint, onDiscretePointsOrderChange: onDiscretePointsOrderChange, onMoveFinish: onMoveFinish, onParamsChange: onParamsChange, onRemoveFunctionPoint: onRemoveFunctionPoint, onUpdateFunctionPoint: onUpdateFunctionPoint }) })] }));
});

var css$2 = ".RadarRendererAbstract_module_preview__dde9baaf {\n  width: 80px;\n  height: 80px;\n}\n.RadarRendererAbstract_module_hint__dde9baaf {\n  max-width: 200px;\n}\n.RadarRendererAbstract_module_popover__dde9baaf {\n  height: 320px;\n  width: 320px;\n}\n";
var modules_f913c579 = {"preview":"RadarRendererAbstract_module_preview__dde9baaf","hint":"RadarRendererAbstract_module_hint__dde9baaf","popover":"RadarRendererAbstract_module_popover__dde9baaf"};
n(css$2,{});

const RADAR_PREVIEW_PROPS = {
    margin: { left: 40, right: 40, top: 40, bottom: 40 },
};
const RADAR_TABLE_PROPS = {
    width: 80,
    height: 80,
};
const COLOR = theme.defaultSeed.colorPrimary;
const POLYGON_STYLES = { fillOpacity: 0.1, fill: '#12939A' };
const RadarRendererAbstract = ({ columnIds, columnIndices, order, score, scoringFunction, }) => {
    const [keys, values] = useMemo(() => {
        const items = order
            .filter((col) => columnIds.includes(col))
            .filter((col) => scoringFunction[col].isInUse)
            .map((col) => columnIndices[col])
            .map((index) => {
            const factor = (score && score.rawValues[index]) ?? 0;
            const colId = columnIds[Number(index)];
            return [
                { label: colId, props: { fill: scoringFunction[colId].color } },
                factor,
            ];
        })
            .reduce((acc, [key, value]) => {
            acc[0].push(key);
            acc[1].push(value);
            return acc;
        }, [[], []]);
        if (items[0].length < 3) {
            return [null, null];
        }
        return items;
    }, [order, columnIds, scoringFunction, columnIndices, score]);
    if (score.value === null || !Object.keys(score.factors).length) {
        return (jsx(Popover, { content: "Scoring is N/A, radar plot cannot be built", overlayClassName: modules_f913c579.hint, placement: "bottom", children: jsx("div", { className: "text-center", children: "N/A" }) }));
    }
    if (!keys || !values) {
        return (jsx(Popover, { content: "Radar plot cannot be built cause there are less than 3 parameters in the scoring function", overlayClassName: modules_f913c579.hint, placement: "bottom", children: jsx("div", { className: "text-center", children: "N/A" }) }));
    }
    const popoverRadarProps = {
        data: [{ points: values, props: POLYGON_STYLES }],
        labels: keys,
        levels: keys.length,
        margin: RADAR_PREVIEW_PROPS.margin,
        strokeColor: theme.defaultSeed.colorPrimary,
    };
    const radarProps = {
        ...RADAR_TABLE_PROPS,
        data: [{ points: values, props: { fill: 'transparent', stroke: COLOR } }],
        labels: keys,
        levels: keys.length,
        margin: RADAR_PREVIEW_PROPS.margin,
        strokeColor: theme.defaultSeed.colorPrimary,
    };
    return (jsx(Popover, { content: jsx("div", { className: modules_f913c579.popover, children: jsx(ResponsiveContainer, { component: RadarChart, ...popoverRadarProps }) }), placement: "right", children: jsx("div", { className: "text-center", children: jsx("div", { className: modules_f913c579.preview, children: jsx(ResponsiveContainer, { component: RadarChart, ...radarProps }) }) }) }));
};

var css$1 = "/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n:root {\n  --dataset-sider-width: 320px;\n}\n.RequiredMark_module_required__406b679e {\n  color: #e7615a;\n  font-size: 12px;\n}\n";
var modules_82a7c864 = {"required":"RequiredMark_module_required__406b679e"};
n(css$1,{});

const RequiredMark = () => {
    return (jsx(Tooltip, { title: "Value is required", children: jsx("span", { className: modules_82a7c864.required, children: "*" }) }));
};

var css = ".LoadingSpinner_module_spinner__9c4d0506 {\n  z-index: 1000;\n  background-color: rgba(255, 255, 255, 0.7);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n";
var modules_3e5c394f = {"spinner":"LoadingSpinner_module_spinner__9c4d0506"};
n(css,{});

const LoadingSpinner = () => {
    return jsx(Spin, { className: modules_3e5c394f.spinner });
};

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}

let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = { randomUUID };

function v4(options, buf, offset) {
    if (native.randomUUID && !buf && !options) {
        return native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
        for (let i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return unsafeStringify(rnds);
}

const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const showEntityDeleteNotification = (params) => {
    const key = v4();
    notification.info({
        icon: jsx(CheckCircleOutlined, { style: { color: '#01579b' } }),
        message: (jsxs("div", { children: [params.entity.parentId ? (jsxs("span", { children: ["Version ", jsx("b", { children: params.entity.versionName }), " of ", jsx("b", { children: params.entity.name }), ' ', params.entityName, " is deleted."] })) : (jsxs("span", { children: [capitalizeFirstLetter(params.entityName), " ", jsx("b", { children: params.entity.name }), " is deleted."] })), jsx("br", {}), "You can restore it."] })),
        btn: (jsx(Button, { size: "small", type: "primary", onClick: () => {
                params.onRestore();
                notification.destroy(key);
            }, children: "Restore template" })),
        key,
        duration: 10, // 10 seconds - business requirement
    });
};

const MultiplePropertiesSelector = (props) => (jsx(AntComponentsProvider, { children: jsx(MultiplePropertiesSelectorGeneric, { ...props }) }));
const MultiplePropertiesSelectorPure = (props) => (jsx(AntComponentsProvider, { children: jsx(MultiplePropertiesSelectorPureGeneric, { ...props }) }));

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function invariant(condition, format, ...args) {
    if (isProduction()) {
        if (format === undefined) {
            throw new Error('invariant requires an error message argument');
        }
    }
    if (!condition) {
        let error;
        if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function isProduction() {
    return typeof process !== 'undefined' && process.env['NODE_ENV'] === 'production';
}

// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function get(obj, path, defaultValue) {
    return path.split('.').reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null
    , obj);
}
/**
 * drop-in replacement for _.without
 */ function without$1(items, item) {
    return items.filter((i)=>i !== item
    );
}
/**
 * drop-in replacement for _.isString
 * @param input
 */ function isObject(input) {
    return typeof input === 'object';
}
/**
 * replacement for _.xor
 * @param itemsA
 * @param itemsB
 */ function xor(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) {
            result.push(key);
        }
    });
    return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ function intersection(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1
    );
}

const INIT_COORDS = 'dnd-core/INIT_COORDS';
const BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
const PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
const HOVER = 'dnd-core/HOVER';
const DROP = 'dnd-core/DROP';
const END_DRAG = 'dnd-core/END_DRAG';

function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: INIT_COORDS,
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

const ResetCoordinatesAction = {
    type: INIT_COORDS,
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function createBeginDrag(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource =true , clientOffset , getSourceClientOffset ,  } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch(setClientOffset(clientOffset));
        verifyInvariants$1(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) {
                throw new Error('getSourceClientOffset must be defined');
            }
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) {
            return undefined;
        }
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: BEGIN_DRAG,
            payload: {
                itemType,
                item,
                sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function verifyInvariants$1(sourceIds, monitor, registry) {
    invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        invariant(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    invariant(isObject(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--){
        if (monitor.canDragSource(sourceIds[i])) {
            sourceId = sourceIds[i];
            break;
        }
    }
    return sourceId;
}

function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function createDrop(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyInvariants(monitor);
        const targetIds = getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: DROP,
                payload: {
                    dropResult: _objectSpread$4({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function verifyInvariants(monitor) {
    invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') {
        dropResult = index === 0 ? {} : monitor.getDropResult();
    }
    return dropResult;
}
function verifyDropResultType(dropResult) {
    invariant(typeof dropResult === 'undefined' || isObject(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

function createEndDrag(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: END_DRAG
        };
    };
}
function verifyIsDragging(monitor) {
    invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) {
        return targetType === null;
    }
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType
    ) : targetType === draggedItemType;
}

function createHover(manager) {
    return function hover(targetIdsArg, { clientOffset  } = {}) {
        verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        const draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        checkInvariants(targetIds, monitor, registry);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: HOVER,
            payload: {
                targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function verifyTargetIdsIsArray(targetIdsArg) {
    invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
    invariant(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        const target = registry.getTarget(targetId);
        invariant(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!matchesType(targetType, draggedItemType)) {
            targetIds.splice(i, 1);
        }
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

function createPublishDragSource(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) {
            return {
                type: PUBLISH_DRAG_SOURCE
            };
        }
        return;
    };
}

function createDragDropActions(manager) {
    return {
        beginDrag: createBeginDrag(manager),
        publishDragSource: createPublishDragSource(manager),
        hover: createHover(manager),
        drop: createDrop(manager),
        endDrag: createEndDrag(manager)
    };
}

class DragDropManagerImpl {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch  } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== 'undefined') {
                    dispatch(action);
                }
            };
        }
        const actions = createDragDropActions(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}

/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ function getSourceClientOffset(state) {
    const { clientOffset , initialClientOffset , initialSourceClientOffset  } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
        return null;
    }
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ function getDifferenceFromInitialOffset(state) {
    const { clientOffset , initialClientOffset  } = state;
    if (!clientOffset || !initialClientOffset) {
        return null;
    }
    return subtract(clientOffset, initialClientOffset);
}

const NONE = [];
const ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === NONE) {
        return false;
    }
    if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
        return true;
    }
    const commonIds = intersection(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

class DragDropMonitorImpl {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds  } = options;
        invariant(typeof listener === 'function', 'listener must be a function.');
        invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) {
                    listener();
                }
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        invariant(typeof listener === 'function', 'listener must be a function.');
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) {
                return;
            }
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId);
        invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) {
            return false;
        }
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const target = this.registry.getTarget(targetId);
        invariant(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) {
            return false;
        }
        const source = this.registry.getSource(sourceId, true);
        invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) {
            return false;
        }
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) {
            return false;
        }
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) {
            return false;
        }
        const { shallow  } = options;
        if (!this.isDragging()) {
            return false;
        }
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !matchesType(targetType, draggedItemType)) {
            return false;
        }
        const targetIds = this.getTargetIds();
        if (!targetIds.length) {
            return false;
        }
        const index = targetIds.indexOf(targetId);
        if (shallow) {
            return index === targetIds.length - 1;
        } else {
            return index > -1;
        }
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return getSourceClientOffset(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const scope = typeof global !== 'undefined' ? global : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const makeRequestCall = typeof BrowserMutationObserver === 'function' ? // reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
makeRequestCallFromMutationObserver : // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
makeRequestCallFromTimer;

class AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++){
                        q[scan] = q[scan + this.index];
                    }
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = makeRequestCall(this.flush);
        this.requestErrorThrow = makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) {
                throw this.pendingErrors.shift();
            }
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

// `call`, just like a function.
class RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}

class TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new RawTask(this.onError, (t)=>tasks[tasks.length] = t
        );
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}

const asapQueue = new AsapQueue();
const taskFactory = new TaskFactory(asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ function asap(task) {
    asapQueue.enqueueTask(taskFactory.create(task));
}

const ADD_SOURCE = 'dnd-core/ADD_SOURCE';
const ADD_TARGET = 'dnd-core/ADD_TARGET';
const REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
const REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        payload: {
            sourceId
        }
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        payload: {
            targetId
        }
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        payload: {
            sourceId
        }
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        payload: {
            targetId
        }
    };
}

function validateSourceContract(source) {
    invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
    invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>validateType(t, false)
        );
        return;
    }
    invariant(typeof type === 'string' || typeof type === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

var HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

let nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

function getNextHandlerId(role) {
    const id = getNextUniqueId().toString();
    switch(role){
        case HandlerRole.SOURCE:
            return `S${id}`;
        case HandlerRole.TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return HandlerRole.SOURCE;
        case 'T':
            return HandlerRole.TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done , value: [, value] ,  } = entries.next();
        if (value === searchValue) {
            return true;
        }
        isDone = !!done;
    }while (!isDone)
    return false;
}
class HandlerRegistryImpl {
    addSource(type, source) {
        validateType(type);
        validateSourceContract(source);
        const sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
        this.store.dispatch(addSource(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        validateType(type, true);
        validateTargetContract(target);
        const targetId = this.addHandler(HandlerRole.TARGET, type, target);
        this.store.dispatch(addTarget(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === HandlerRole.SOURCE;
    }
    isTargetId(handlerId) {
        const role = parseRoleFromHandlerId(handlerId);
        return role === HandlerRole.TARGET;
    }
    removeSource(sourceId) {
        invariant(this.getSource(sourceId), 'Expected an existing source.');
        this.store.dispatch(removeSource(sourceId));
        asap(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        invariant(this.getTarget(targetId), 'Expected an existing target.');
        this.store.dispatch(removeTarget(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        invariant(source, 'Expected an existing source.');
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        invariant(this.pinnedSource, 'No source is pinned at the time.');
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = getNextHandlerId(role);
        this.types.set(id, type);
        if (role === HandlerRole.SOURCE) {
            this.dragSources.set(id, handler);
        } else if (role === HandlerRole.TARGET) {
            this.dropTargets.set(id, handler);
        }
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}

const strictEquality = (a, b)=>a === b
;
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) {
        return true;
    } else if (!offsetA || !offsetB) {
        return false;
    } else {
        return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
    }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ function areArraysEqual(a, b, isEqual = strictEquality) {
    if (a.length !== b.length) {
        return false;
    }
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) {
            return false;
        }
    }
    return true;
}

function reduce$5(// eslint-disable-next-line @typescript-eslint/no-unused-vars
_state = NONE, action) {
    switch(action.type){
        case HOVER:
            break;
        case ADD_SOURCE:
        case ADD_TARGET:
        case REMOVE_TARGET:
        case REMOVE_SOURCE:
            return NONE;
        case BEGIN_DRAG:
        case PUBLISH_DRAG_SOURCE:
        case END_DRAG:
        case DROP:
        default:
            return ALL;
    }
    const { targetIds =[] , prevTargetIds =[]  } = action.payload;
    const result = xor(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);
    if (!didChange) {
        return NONE;
    }
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) {
            result.push(prevInnermostTargetId);
        }
        if (innermostTargetId) {
            result.push(innermostTargetId);
        }
    }
    return result;
}

function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
const initialState$1 = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function reduce$4(state = initialState$1, action) {
    const { payload  } = action;
    switch(action.type){
        case INIT_COORDS:
        case BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case HOVER:
            if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
                return state;
            }
            return _objectSpread$3({}, state, {
                clientOffset: payload.clientOffset
            });
        case END_DRAG:
        case DROP:
            return initialState$1;
        default:
            return state;
    }
}

function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
const initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function reduce$3(state = initialState, action) {
    const { payload  } = action;
    switch(action.type){
        case BEGIN_DRAG:
            return _objectSpread$2({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case PUBLISH_DRAG_SOURCE:
            return _objectSpread$2({}, state, {
                isSourcePublic: true
            });
        case HOVER:
            return _objectSpread$2({}, state, {
                targetIds: payload.targetIds
            });
        case REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) {
                return state;
            }
            return _objectSpread$2({}, state, {
                targetIds: without$1(state.targetIds, payload.targetId)
            });
        case DROP:
            return _objectSpread$2({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case END_DRAG:
            return _objectSpread$2({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

function reduce$2(state = 0, action) {
    switch(action.type){
        case ADD_SOURCE:
        case ADD_TARGET:
            return state + 1;
        case REMOVE_SOURCE:
        case REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

function reduce$1(state = 0) {
    return state + 1;
}

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function reduce(state = {}, action) {
    return {
        dirtyHandlerIds: reduce$5(state.dirtyHandlerIds, {
            type: action.type,
            payload: _objectSpread$1({}, action.payload, {
                prevTargetIds: get(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: reduce$4(state.dragOffset, action),
        refCount: reduce$2(state.refCount, action),
        dragOperation: reduce$3(state.dragOperation, action),
        stateId: reduce$1(state.stateId)
    };
}

function createDragDropManager(backendFactory, globalContext = undefined, backendOptions = {}, debugMode = false) {
    const store = makeStoreInstance(debugMode);
    const monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
    const manager = new DragDropManagerImpl(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return createStore(reduce, debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}

// cheap lodash replacements
function memoize(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) {
            result = fn();
        }
        return result;
    };
    return memoized;
}
/**
 * drop-in replacement for _.without
 */ function without(items, item) {
    return items.filter((i)=>i !== item
    );
}
function union(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item)
    ;
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key)
    );
    return result;
}

class EnterLeaveCounter {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode))
        ;
        this.entered = union(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = without(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}

class NativeDragSource {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) {
                    newProperties[property] = {
                        value: propertyFn(dataTransfer, this.config.matchesTypes),
                        configurable: true,
                        enumerable: true
                    };
                }
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}

const FILE = '__NATIVE_FILE__';
const URL = '__NATIVE_URL__';
const TEXT = '__NATIVE_TEXT__';
const HTML = '__NATIVE_HTML__';

var NativeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FILE: FILE,
  HTML: HTML,
  TEXT: TEXT,
  URL: URL
});

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry)
    , '');
    return result != null ? result : defaultValue;
}

const nativeTypesConfig = {
    [FILE]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files)
            ,
            items: (dataTransfer)=>dataTransfer.items
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Files'
        ]
    },
    [HTML]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Html',
            'text/html'
        ]
    },
    [URL]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Url',
            'text/uri-list'
        ]
    },
    [TEXT]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>getDataFromDataTransfer(dataTransfer, matchesTypes, '')
            ,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            'Text',
            'text/plain'
        ]
    }
};

function createNativeDragSource(type, dataTransfer) {
    const config = nativeTypesConfig[type];
    if (!config) {
        throw new Error(`native type ${type} has no configuration`);
    }
    const result = new NativeDragSource(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) {
        return null;
    }
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys(nativeTypesConfig).filter((nativeItemType)=>{
        const typeConfig = nativeTypesConfig[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) {
            return false;
        }
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1
        );
    })[0] || null;
}

const isFirefox = memoize(()=>/firefox/i.test(navigator.userAgent)
);
const isSafari = memoize(()=>Boolean(window.safari)
);

class MonotonicInterpolant {
    interpolate(x) {
        const { xs , ys , c1s , c2s , c3s  } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) {
            return ys[i];
        }
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) {
                low = mid + 1;
            } else if (xHere > x) {
                high = mid - 1;
            } else {
                return ys[mid];
            }
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length  } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++){
            indexes.push(i);
        }
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1
        );
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) {
                c1s.push(0);
            } else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}

const ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    const el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) {
        return null;
    }
    const { top , left  } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    var ref;
    return node.nodeName === 'IMG' && (isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if (isSafari() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth,
        dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth , offsetHeight: sourceHeight  } = sourceNode;
    const { anchorX , anchorY  } = anchorPoint;
    const { dragPreviewWidth , dragPreviewHeight  } = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            (offsetFromDragPreview.y / sourceHeight) * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight, 
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if (isSafari() && isImage) {
            // We'll have to wait for @3x to see if this is entirely correct
            y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        }
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new MonotonicInterpolant([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            (offsetFromDragPreview.x / sourceWidth) * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth, 
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX , offsetY  } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

class OptionsReader {
    get window() {
        if (this.globalContext) {
            return this.globalContext;
        } else if (typeof window !== 'undefined') {
            return window;
        }
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) {
            return this.globalContext.document;
        } else if (this.window) {
            return this.window.document;
        } else {
            return undefined;
        }
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class HTML5BackendImpl {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        if (root.__isReactDndBackendSetUp) {
            throw new Error('Cannot have two HTML5 backends at the same time.');
        }
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) {
            return;
        }
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 ? void 0 : ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId)
        ;
        const handleSelectStart = (e)=>this.handleSelectStart(e)
        ;
        node.setAttribute('draggable', 'true');
        node.addEventListener('dragstart', handleDragStart);
        node.addEventListener('selectstart', handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener('dragstart', handleDragStart);
            node.removeEventListener('selectstart', handleSelectStart);
            node.setAttribute('draggable', 'false');
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId)
        ;
        const handleDragOver = (e)=>this.handleDragOver(e, targetId)
        ;
        const handleDrop = (e)=>this.handleDrop(e, targetId)
        ;
        node.addEventListener('dragenter', handleDragEnter);
        node.addEventListener('dragover', handleDragOver);
        node.addEventListener('drop', handleDrop);
        return ()=>{
            node.removeEventListener('dragenter', handleDragEnter);
            node.removeEventListener('dragover', handleDragOver);
            node.removeEventListener('drop', handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) {
            return;
        }
        target.addEventListener('dragstart', this.handleTopDragStart);
        target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.addEventListener('dragend', this.handleTopDragEndCapture, true);
        target.addEventListener('dragenter', this.handleTopDragEnter);
        target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.addEventListener('dragover', this.handleTopDragOver);
        target.addEventListener('dragover', this.handleTopDragOverCapture, true);
        target.addEventListener('drop', this.handleTopDrop);
        target.addEventListener('drop', this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) {
            return;
        }
        target.removeEventListener('dragstart', this.handleTopDragStart);
        target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
        target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
        target.removeEventListener('dragenter', this.handleTopDragEnter);
        target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
        target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
        target.removeEventListener('dragover', this.handleTopDragOver);
        target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
        target.removeEventListener('drop', this.handleTopDrop);
        target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return _objectSpread({
            dropEffect: this.altKeyPressed ? 'copy' : 'move'
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) {
            // It makes more sense to default to 'copy' for native resources
            return 'copy';
        }
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return _objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys(NativeTypes).some((key)=>NativeTypes[key] === itemType
        );
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = createNativeDragSource(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 ? void 0 : ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) {
            return;
        }
        if (!this.dragStartSourceIds) {
            this.dragStartSourceIds = [];
        }
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) {
            this.dragOverTargetIds = [];
        }
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && getNodeClientOffset(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) {
                return;
            }
            this.actions.endDrag();
            if (this.currentNativeHandle) {
                this.registry.removeSource(this.currentNativeHandle);
            }
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) {
                return;
            }
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') {
                this.hoverRafId = requestAnimationFrame(()=>{
                    if (this.monitor.isDragging()) {
                        this.actions.hover(dragOverTargetIds || [], {
                            clientOffset: this.lastClientOffset
                        });
                    }
                    this.hoverRafId = null;
                });
            }
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== 'undefined') {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) {
                return;
            }
            const { dragStartSourceIds  } = this;
            this.dragStartSourceIds = null;
            const clientOffset = getEventClientOffset(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset
            });
            const { dataTransfer  } = e;
            const nativeType = matchNativeItemType(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX , anchorY , offsetX , offsetY  } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX,
                            anchorY
                        };
                        const offsetPoint = {
                            offsetX,
                            offsetY
                        };
                        const dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState  } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) {
                    // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(()=>this.actions.publishDragSource()
                    , 0);
                } else {
                    // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    this.actions.publishDragSource();
                }
            } else if (nativeType) {
                // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
            } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
                // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return;
            } else {
                // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
                // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) {
                return;
            }
            const { dataTransfer  } = e;
            const nativeType = matchNativeItemType(dataTransfer);
            if (nativeType) {
                // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType, dataTransfer);
            }
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds  } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                return;
            }
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) {
                this.actions.hover(dragEnterTargetIds, {
                    clientOffset: getEventClientOffset(e)
                });
            }
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds  } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = getEventClientOffset(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId)
            );
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            } else if (this.isDraggingNativeItem()) {
                // Don't show a nice cursor but still prevent default
                // "drop and blow away the whole document" action.
                e.preventDefault();
            } else {
                e.preventDefault();
                if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'none';
                }
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) {
                e.preventDefault();
            }
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) {
                return;
            }
            if (this.isDraggingNativeItem()) {
                setTimeout(()=>this.endDragNativeItem()
                , 0);
            }
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
            } else if (matchNativeItemType(e.dataTransfer)) {
                // Dragging some elements, like <a> and <img> may still behave like a native drag event,
                // even if the current drag event matches a user-defined type.
                // Stop the default behavior when we're not expecting a native item to be dropped.
                e.preventDefault();
            }
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds  } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: getEventClientOffset(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) {
                this.endDragNativeItem();
            } else if (this.monitor.isDragging()) {
                this.actions.endDrag();
            }
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') {
                return;
            }
            // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
                return;
            }
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new OptionsReader(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
    }
}

const HTML5Backend = function createBackend(manager, context, options) {
    return new HTML5BackendImpl(manager, context, options);
};

const IsolatedDndProvider = ({ children }) => {
    const ref = useRef(null);
    const [manager, setManager] = useState(null);
    useLayoutEffect(() => {
        if (!ref.current)
            return;
        setManager(ref.current
            ? createDragDropManager(HTML5Backend, null, { rootElement: ref.current })
            : null);
    }, []);
    return (jsx("div", { ref: ref, style: { width: 'inherit', height: 'inherit' }, children: manager && jsx(DndProvider, { manager: manager, children: children }) }));
};

export { AntComponentsProvider, ColorPickerPure, ColumnColorMultiSelector, DatasetDetails, DesirabilityFunction, ImportanceSliderView, IsolatedDndProvider, LoadingSpinner, MultiplePropertiesSelector, MultiplePropertiesSelectorPure, RadarRendererAbstract, RequiredMark, ScoreRendererAbstract, ValueInput, showEntityDeleteNotification };
//# sourceMappingURL=index.js.map
